var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'preview-style': _vm.preview },attrs:{"id":"ds-main-wrapper"}},[_c('div',{staticClass:"inner"},[_c('Parser',{attrs:{"media":_vm.presentationData.media,"screen-type":_vm.screenType}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }